// extracted by mini-css-extract-plugin
export default {"section_about_skills":"App_section_about_skills__QBDmQ","section_dark":"App_section_dark__uMh+X","section_light":"App_section_light__PpaU+"};